import { __extends } from "tslib";
import React, { Component } from 'react';
import FormSectionWrapper, { FormSectionDescription, FormSectionTitle, } from './styled/FormSection';
var FormSection = /** @class */ (function (_super) {
    __extends(FormSection, _super);
    function FormSection() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FormSection.prototype.render = function () {
        var _a = this.props, title = _a.title, description = _a.description, children = _a.children;
        return (React.createElement(FormSectionWrapper, null,
            title && React.createElement(FormSectionTitle, null, title),
            description && (React.createElement(FormSectionDescription, null, description)),
            children));
    };
    return FormSection;
}(Component));
export default FormSection;
//# sourceMappingURL=FormSection.js.map